import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Country } from "utils/countries";

const useLanguage = () => {
  const { i18n } = useTranslation();

  return useMemo(() => i18n.language.slice(0, 2) as Country, [i18n.language]);
};

export default useLanguage;
